export default __webpack_public_path__ + "static/media/Icon-Plus-Grey.fe329407.svg";